import { tv } from 'tailwind-variants';

export const relatedTopicsVariants = tv({
  slots: {
    headerBar: ['w-full', 'bg-primary'],
    headerText: [
      'text-white',
      'font-medium',
      'uppercase',
      // 'tracking-widest',
      'text-lg',
      'text-center',
      'px-0.5',
      'py-1',
      'font-black',
      'leading-5.5'
    ],
    grid: [
      'max-w-page-template',
      'mx-auto',
      'px-2',
      'md:px-7.5',
      'py-6',
      'grid',
      'grid-cols-1',
      'md:grid-cols-3',
      'gap-4',
      'md:gap-7.5'
    ],
    card: ['bg-white', 'mx-3.75', 'md:mx-0'],
    imageContainer: ['w-full', 'overflow-hidden'],
    cardBody: ['p-4'],
    cardwrapper: [
      'text-primary',
      'font-medium',
      'text-lg',
      'leading-tight',
      'hover:underline',
      'block',
      'mb-3',
    ],
    cardTitle: [
      'text-primary',
      'font-semibold',
      'leading-5.5!',
      'border-b',
      'border-solid',
      'text-lg',
      'pt-3.75',
      'pb-5',
      'mx-4'
    ],
    divider: ['border-0', 'border-t', 'border-light-gray', 'my-4'],
    cardDescription: ['text-lg', 'text-light-black', 'leading-6.75', 'pb-6 px-4','font-light', 'mb-4'],
  },
});
